import { onReady } from "@otto-ec/global-resources/dom";
import type { Props } from "../CinemaV1.types";
import { calcItemsPerPage } from "../math/calcItemsPerPage";
import { calcScrollPositions } from "../math/calcScrollPositions";

/**
 *
 */
type StageControlState = {
  /**
 *
 *
 *
 */
  setStageScrollWidth(value: number): void;
  /**
 *
 *
 *
 */
  hideLeftArrow(): boolean;
  /**
 *
 *
 *
 */
  hideRightArrow(): boolean;
  /*                                                       */
  stretchItems(): boolean;
  /**
 *
 *
 *
 */
  currentPage(): number;
  /**
 *
 *
 *
 */
  itemsPerPage(): number;
  /**
 *
 *
 *
 */
  scrollPoints(): number[];
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const useStageControlsState = (
  Host: HTMLOcCinemaV1Element,
  props: Pick<Props, "itemsPerPage" | "resizing">,
  items: () => HTMLElement[],
  stageElement: () => HTMLElement | undefined,
  stageScrollLeft: () => number,
  stageClientWidth: () => number,
): StageControlState => {
  let ready = $state(false);
  onReady.sub(() => (ready = true));

  /*                                                                                                                       */
  const update = $derived(ready && [stageElement(), stageClientWidth(), items()] ? Date.now() : 0);

  let stageScrollWidth = $state(0);

  /*            */
  const itemGap = $derived(
    stageElement() && update
      ? parseFloat(getComputedStyle(stageElement()!).getPropertyValue("--gap"))
      : 0,
  );

  /*            */
  const stageSpacing = $derived(
    stageElement() && update
      ? parseFloat(getComputedStyle(stageElement()!).getPropertyValue("--stage-spacing"))
      : 0,
  );

  /*            */
  const itemCut = $derived(
    stageElement() && update
      ? parseFloat(getComputedStyle(stageElement()!).getPropertyValue("--cut"))
      : 0,
  );

  /*            */
  const userDefinedItemsPerPage = $derived(
    update
      ? parseFloat(
          props.itemsPerPage ?? getComputedStyle(Host).getPropertyValue("--items-per-page"),
        )
      : 0,
  );

  const hideLeftArrow = $derived(!!update && (isNaN(itemGap) || stageScrollLeft() <= itemGap));

  const hideRightArrow = $derived(
    !!update &&
      (isNaN(itemGap) || stageScrollLeft() >= stageScrollWidth - stageClientWidth() - itemGap),
  );

  const itemsPerPage = $derived.by(() => {
    if (userDefinedItemsPerPage && !isNaN(userDefinedItemsPerPage)) {
      return userDefinedItemsPerPage;
    }
    return calcItemsPerPage(stageClientWidth(), itemGap, itemCut, stageSpacing);
  });

  /*                                                                                         */
  const stretchItems = $derived(
    props.resizing === "stretch" ||
      (props.resizing === "stretch-cut" && itemsPerPage >= items().length),
  );

  const scrollPoints = $derived(
    stageScrollWidth
      ? calcScrollPositions(items(), stageClientWidth(), itemGap, stageSpacing)
      : [0],
  );

  const currentPage = $derived.by(() => {
    /*                                          */
    if (stageScrollLeft() <= 0) return 0;

    /*                                                                                    */
    if (stageScrollLeft() >= stageScrollWidth - stageClientWidth() - itemGap)
      return scrollPoints.length - 1;

    /*                                              */
    const pageTransitionsPoints = scrollPoints.map((p, i) => ((scrollPoints[i - 1] ?? 0) + p) / 2);

    const index = pageTransitionsPoints.findIndex((point) => point > stageScrollLeft());

    /*                                                                                                                        */
    /*                                                                                                                 */
    return index === -1 ? scrollPoints.length - 1 : index - 1;
  });

  const state: StageControlState = {
    setStageScrollWidth: (value: number) => (stageScrollWidth = value),
    hideLeftArrow: () => hideLeftArrow,
    hideRightArrow: () => hideRightArrow,
    stretchItems: () => stretchItems,
    currentPage: () => currentPage,
    itemsPerPage: () => itemsPerPage,
    scrollPoints: () => scrollPoints,
  };

  $effect(() => {
    const stage = stageElement();

    if (stage && update) {
      /*                                                                     */
      requestAnimationFrame(() => {
        stageScrollWidth = stage.scrollWidth;
      });
    }
  });

  return state;
};
